import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function RoundButton(props: { id?: string, icon : IconName, onClick : () => void, title : string, ref? : any, className? : string, iconColor?:string, backgroundColor?:string, borderColor?:string, text? : string }) {
  const clicked = () => {
    props.onClick();
  }

  const colors = {
    color: props.iconColor ? props.iconColor : "#6c757d",
    backgroundColor: props.backgroundColor ? props.backgroundColor : "#ced4da",
    borderColor: props.borderColor ? props.borderColor : "#6c757d"
  };
  const buttonText = props.text ? props.text : null;
  const textClass = props.text ? "round-border-button-text" : null;

  return <button 
    id={props.id} 
    className={`round-border-button ${props?.className} ${textClass}`} 
    style={colors} 
    ref={props.ref} 
    title={props.title} 
    aria-label={props.title} 
    onClick={clicked}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = darkenColor(colors.backgroundColor, 10);
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = colors.backgroundColor;
    }}
  >
    <FontAwesomeIcon icon={props?.icon} /> {buttonText}
  </button>;
}

function darkenColor(color: string, percent: number): string {
  const num = parseInt(color.replace("#", ""), 16),
    amt = Math.round(2.55 * percent),
    R = (num >> 16) - amt,
    G = (num >> 8 & 0x00FF) - amt,
    B = (num & 0x0000FF) - amt;
  return "#" + (0x1000000 + (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    (B < 255 ? (B < 1 ? 0 : B) : 255)).toString(16).slice(1);
}
